export default "__VITE_PUBLIC_ASSET__89dd4eb2__"